import config from 'tailwind.config';
import resolveConfig from 'tailwindcss/resolveConfig';
import { DefaultColors } from 'tailwindcss/types/generated/colors';

export const tailwindFullConfig = resolveConfig(config);
export const colors: Record<string, any> = tailwindFullConfig.theme
  ?.colors as DefaultColors;
